import { render, staticRenderFns } from "./ImageDropzone.vue?vue&type=template&id=051214fa&scoped=true&"
import script from "./ImageDropzone.vue?vue&type=script&lang=js&"
export * from "./ImageDropzone.vue?vue&type=script&lang=js&"
import style0 from "./ImageDropzone.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ImageDropzone.vue?vue&type=style&index=1&id=051214fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051214fa",
  null
  
)

export default component.exports